import { LOGIN } from '../../routes/APP_URLS';

export const doSetNextRouteAndRedirect =
  (pathname) =>
  async ({ dispatch }) => {
    dispatch({ actionCreator: 'doReplaceUrl', args: [LOGIN] });
    dispatch({ actionCreator: 'doSetNextRouteLocation', args: [{ pathname }] });
  };
